import React, { useEffect, useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import {
  FaSearch,
  FaUserPlus,
  FaArrowLeft,
  FaCar,
  FaChartLine,
  FaShieldAlt,
  FaCheckCircle,
  FaRobot,
  FaStar,
} from 'react-icons/fa';
import './DemoExitModal.css';

const DemoExitModal = ({
  show,
  onHide,
  onSignUp,
  onBrowseAsGuest,
  onStayInDemo,
  intendedDestination = '/',
}) => {
  const [theme, setTheme] = useState(
    document.documentElement.getAttribute('data-theme') || 'light'
  );

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-theme') {
          setTheme(
            document.documentElement.getAttribute('data-theme') || 'light'
          );
        }
      });
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });
    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: <FaSearch />,
      title: 'Search Any VIN',
      desc: 'Run unlimited vehicle history searches',
      color: '#00abe4',
    },
    {
      icon: <FaCar />,
      title: 'Your Own Garage',
      desc: 'Save & manage all your vehicles',
      color: '#0099cc',
    },
    {
      icon: <FaRobot />,
      title: 'AI-Powered Insights',
      desc: 'Get intelligent analysis on every report',
      color: '#33bfe9',
    },
    {
      icon: <FaChartLine />,
      title: 'Full Vehicle Reports',
      desc: 'Damage, recalls, ownership & more',
      color: '#00abe4',
    },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      className="demo-exit-modal"
    >
      <div className="dem-wrapper" data-theme={theme}>
        {/* Decorative blobs */}
        <div className="dem-blob dem-blob-1" />
        <div className="dem-blob dem-blob-2" />

        {/* Header */}
        <div className="dem-header">
          <div className="dem-icon-orb">
            <FaStar size={28} />
          </div>
          <h3
            className="dem-title"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            You've Seen What We Can Do
          </h3>
          <p className="dem-subtitle">
            Now it's time to search <em>your</em> vehicle. Create a free account
            and run your first VIN report in seconds.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="dem-body">
          <Row className="g-3">
            {features.map((feature, index) => (
              <Col xs={6} key={index}>
                <div className="dem-feature-card">
                  <div
                    className="dem-feature-icon"
                    style={{
                      background: `linear-gradient(135deg, ${feature.color}22, ${feature.color}11)`,
                      color: feature.color,
                    }}
                  >
                    {feature.icon}
                  </div>
                  <div className="dem-feature-title">{feature.title}</div>
                  <div className="dem-feature-desc">{feature.desc}</div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* CTA Section */}
        <div className="dem-footer">
          {/* Primary CTA */}
          <button className="dem-cta-primary" onClick={onSignUp}>
            <FaUserPlus size={18} />
            Create Free Account & Start Searching
          </button>

          {/* Trust Row */}
          <div className="dem-trust-row">
            <span className="dem-trust-item">
              <FaCheckCircle /> Free forever
            </span>
            <span className="dem-trust-divider" />
            <span className="dem-trust-item">
              <FaShieldAlt /> No credit card
            </span>
            <span className="dem-trust-divider" />
            <span className="dem-trust-item">
              <FaCar /> 75K+ users
            </span>
          </div>

          {/* Back to demo link — subtle, no guest browse option */}
          <button className="dem-back-link" onClick={onStayInDemo}>
            <FaArrowLeft size={12} />
            Back to Demo Garage
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DemoExitModal;
